<template>
  <div class="modal__content-inner">
    <div v-if="image" class="d-flex justify-center">
      <img :src="image" alt="" style="object-fit: contain; max-height: 250px; height: 100%; width: 100%;" />
    </div>
    <div class="modal__head">
      <h3 class="modal__title">{{ title }}</h3>
      <button @click.prevent="$vModal.close('message')"
              class="modal-edit-data__close  base-btn">
        <BaseSvg name="ico-close" width="1rem" height="1rem"/>
      </button>
    </div>
    <OverlayScrollbarsComponent v-if="message"
                                class="modal__scroll-wrap">
      <div class="modal__main  text">
        <p>{{ message }}</p>
      </div>
    </OverlayScrollbarsComponent>
    <div class="modal__footer" :class="{ 'justify-center': buttonCenter }">
      <button @click.prevent="$vModal.close('message')"
              class="modal__btn  base-btn  base-btn--blue">
        <span>{{ btnText || $tGlobal('Close') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
  import 'overlayscrollbars/css/OverlayScrollbars.css'
  import {OverlayScrollbarsComponent} from 'overlayscrollbars-vue'

  export default {
    components: {
      OverlayScrollbarsComponent
    },
    props: {
      title: {
        type: String,
        default: 'Message'
      },
      image: {
        type: String,
        default: null,
      },
      message: {
        type: String
      },
      btnText: {
        type: String,
      },
      buttonCenter: {
        type: Boolean,
        default: false,
      },
    }
  }
</script>

<style lang="less">

</style>
